<template>
  <div class="h-screen">
    <div>
      <HeaderBar :title="hTitle" />
    </div>
    <div class="w-full bg-[#ccc] px-[150px] p-10">
      <img
        src="../../../../../assets/images/movein.png"
        alt=""
        class="w-full"
      />
      <!-- <table class="w-full table1 bg-white border-4 border-gray-400">
        <tr>
          <th
            class="bg-gray-300 text-left align-top border-r border-gray-600 p-2"
          >
            List of Requirements
          </th>
          <th
            class="bg-gray-300 text-left align-top border-r border-gray-600 p-2"
          >
            Inhouse, Vertical
          </th>
          <th
            class="bg-gray-300 text-left align-top border-r border-gray-600 p-2"
          >
            Inhouse, Horizontal
          </th>
          <th
            class="bg-gray-300 text-left align-top border-r border-gray-600 p-2"
          >
            Bank Financing, Vertical
          </th>
          <th
            class="bg-gray-300 text-left align-top border-r border-gray-600 p-2"
          >
            Bank Financing, Horizontal
          </th>
        </tr>

        <tr>
          <td>Registration Fee</td>
          <td>√</td>
          <td>√</td>
          <td>√</td>
          <td>√</td>
        </tr>
        <tr>
          <td>Move-in Fee</td>
          <td></td>
          <td>√</td>
          <td></td>
          <td>√</td>
        </tr>
        <tr>
          <td>Release of Loan Proceeds</td>
          <td></td>
          <td></td>
          <td>√</td>
          <td>√</td>
        </tr>
        <tr>
          <td>Settle at least the 20% of the TCP / down payment</td>
          <td>√</td>
          <td>√</td>
          <td>√</td>
          <td>√</td>
        </tr>
        <tr>
          <td>Issue 24 post-dated checks</td>
          <td>√</td>
          <td>√</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Real Property Tax (advance 3 years)</td>
          <td>√</td>
          <td>√</td>
          <td>√</td>
          <td>√</td>
        </tr>
      </table> -->
    </div>
    <div class="mx-10 my-4">
      <div class="font-xl">Note:</div>
      <div class="my-2">
        The following may not be applicable if you have obtained a special promo
        or approval from Management stating otherwise.
      </div>
      <div class="my-2">
        Move-in Fee for Vertical projects shall be settled directly with Condo
        Corporation, not with Moldex.
      </div>
      <hr  class="my-2"/>
      <div class="my-2">
        Once you have complied with the payments and documents required to
        move-in the unit, you may coordinate with our Turnover Group to schedule
        the acceptance of the unit at turnover@moldex.com.ph or (02) 8373-8888
        local 422.
      </div>
    </div>
  </div>
</template>
<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  components: { HeaderBar },
  props: ["hTitle"],
};
</script>

<style scoped>
.table1 td {
  border: solid #505050 1px;
  padding: 10px;
  text-align: left;
}
</style>